<template>
  <!-- <el-drawer :title="task.Title" :visible.sync="drawer" :direction="direction"> -->
  <div class="viewInfo">
    <el-row
      :gutter="10"
      style="margin-bottom:10px"
      v-for="(item) in workFlowData"
      :key="item.Field"
    >
      <el-col style="text-align:right" :span="6" :offset="3">
        <strong>{{item.FieldName}}:</strong>
      </el-col>
      <el-col v-if="item.input.InputType=='attach'&&item.Value!=''" :span="12">
        <div v-for="(img,index) in item.Value" :key="index">
          <el-image
            v-if="'jpg|gif|png|jpeg'.indexOf(img.substring(img.lastIndexOf('.')+1))>=0"
            style="width: 50px; height: 50px"
            :src="img"
            :preview-src-list="item.Value"
          ></el-image>
          <a
            style="color:#ddd;font-size:20px"
            v-if="'jpg|gif|png|jpeg'.indexOf(img.substring(img.lastIndexOf('.')+1))<0"
            :href="img"
          >
            <i class="el-icon-document"></i>
          </a>
        </div>
      </el-col>
      <el-col v-else-if="item.input.InputType=='detail'" :span="12">
        <ol
          v-for="(v,dindex) in item.Value"
          :key="dindex"
          style="list-style:none;padding-left:5px;text-align:left;"
        >
          <li v-for="(dv) in v" :key="dv.field">
            {{dv.name}}
            :{{dv.value}}
          </li>
        </ol>
      </el-col>
      <el-col v-else :span="12">{{item.Value}}</el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col style="text-align:right" :span="6" :offset="3">
        <strong>审批流程:</strong>
      </el-col>
      <el-col :span="12">
        <el-steps direction="vertical">
          <el-step
            :status="statusFormatter(item)"
            v-for="(item,index) in stepTimeLines"
            :key="index"
            :title="item.Name"
            description="item.Handler"
          >
            <template slot="description" ><span>{{item.Handler+"("+item.ResultMessage+")"}}<br/>{{item.CompletedTime}}</span></template>
          </el-step>
        </el-steps>
      </el-col>
    </el-row>
    <el-row v-if="cancelable" style="position:sticky;bottom:0;background:#ffffff">
      <el-col :span="12" :offset="10">
        <el-button style="margin-bottom:10px" @click="cancel" type="danger" size="small">撤销</el-button>
      </el-col>
    </el-row>
  </div>
  <!-- </el-drawer> -->
</template>
<script>
import {
  GetWorkFlowData,
  GetWorkFlowInput,
  GetFirstSenderId,
  GetStepTimeLine,
  GetFlowCanelable,
  getInputData,
  setDetailData,
  Cancel
} from "../../until/ZeusApiSDK/Logic/WorkFLowLogic";
import { GetSingleSysItem } from "../../until/ZeusApiSDK/Logic/SysItemLogic";
import { GetFrameById } from "../../until/ZeusApiSDK/Logic/StructureLogic";
import { GetCurrentUserInfo } from "../../until/ZeusApiSDK/Logic/HomeLogic";
export default {
  props: {
    task: {
      type: Object
    },
    drawerShow: {
      type: Boolean
    }
  },
  data() {
    return {
      t: this.task,
      workFlowData: [],
      stepTimeLines: [],
      user: {},
      cancelable: false
    };
  },
  created() {
    this.initWorkFlowData();
    this.InitCurrentUser();
    this.GetTimeLine();
    this.setCancelable();
  },
  methods: {
    initWorkFlowData: function() {
      this.workFlowData = [];
      GetWorkFlowData(this.t.FlowID, this.t.InstanceID).then(data => {
        GetWorkFlowInput(this.t.FlowID).then(inputs => {
          data.forEach(async element => {
            var i = inputs.filter(p => p.Field == element.Field);
            if (i.length > 0) {
              element.input = i[0];
              if (i[0].InputType != "hidden") {
                element.Value = await getInputData(i[0], element.Value);
                if (i[0].InputType == "detail") {
                  element.Value = await setDetailData(i[0], element.Value);
                }
                if((typeof  element.Value)=='object'){
                  var newList = [];
                  console.log('https element',element);
                  //循环遍历图片
                  element.Value.forEach(item=>{
                    if(item!=null&& item.indexOf('https') !=-1){
                        //存在字符串
                        item=item.replace("https","http");
                    }
                    newList.push(item);
                  });
                  element.Value=newList;
                }
                this.workFlowData.push(element);
              }
            }
          });
        });
      });
    },
    cancel: function() {
      Cancel(this.t.ID, this.t.FlowID, this.t.InstanceID, this.t.StepID).then(
        res => {
          this.$message({
            message: res.msg,
            type: "success",
            center: true
          });
          this.$emit("update:drawerShow", false);
        }
      );
    },
    GetTimeLine: function() {
      GetStepTimeLine(
        this.user.UserId,
        this.t.FlowID,
        this.t.StepID,
        this.t.InstanceID
      ).then(res => {
        this.stepTimeLines = res.TimeLines;
      });
    },
    setCancelable: async function() {
      if (this.$route.path == "/Flow/UserCreate" && this.t.Status != "5") {
        this.cancelable = await GetFlowCanelable(this.t.FlowID);
      }
    },
    InitCurrentUser: function() {
      this.user = GetCurrentUserInfo();
    },
    statusFormatter: function(item) {
      var status = "wait";
      switch (item.Result) {
        case 0:
          status = "wait";
          break;
        case 1:
          status = "process";
          break;
        case 2:
          status = "success";
          break;
        case 3:
          status = "error";
          break;
        case 4:
          status = "success";
          break;
        case 5:
          status = "error";
          break;
      }
      return status;
    }
  },
  watch: {
    task: {
      handler(n, o) {
        //n为新值,o为旧值;
        this.t = n;
        this.initWorkFlowData();
        this.GetTimeLine();
        this.setCancelable();
      },
      deep: true
    }
  }
};
</script>
<style  lang="less" scoped>
.viewInfo {
  text-align: left;
  font-size: 14px;
  color: #72767b;
}
</style>